var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"blog"},[_c('router-view'),_c('UtterancesComments'),_c('BackButton',{staticClass:"back-btn"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }